var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroatia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_21525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0.000701904H0V32H32V0.000701904Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V10.6664H32V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 21.3335H0V32H32V21.3335Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8396 11.7843H17.2796L17.7062 8.58426L19.413 7.30426L21.1196 8.58426V11.1443L19.8396 11.7843Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1599 11.7843H14.7199L14.2933 8.58426L12.5866 7.30426L10.8799 8.58426V11.1443L12.1599 11.7843Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7064 11.7843H14.2931V8.58426L15.9998 7.30426L17.7064 8.58426V11.7843Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8799 11.1444V18.1844C10.8799 19.8607 11.6897 21.3515 12.9386 22.2859L13.8346 22.0618L14.9653 23.1992C15.2995 23.2681 15.6455 23.3044 15.9999 23.3044C16.3524 23.3044 16.6966 23.2686 17.0293 23.2004L18.3199 22.1258L19.0613 22.284C20.3096 21.3495 21.1199 19.8602 21.1199 18.1844V11.1444H10.8799V11.1444Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9279 11.1443H10.8799V13.1923H12.9279V11.1443Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.024 11.1443H14.976V13.1923H17.024V11.1443Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1198 11.1443H19.0718V13.1923H21.1198V11.1443Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9763 13.1924H12.9283V15.2404H14.9763V13.1924Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.072 13.1924H17.024V15.2404H19.072V13.1924Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9279 15.2396H10.8799V17.2876H12.9279V15.2396Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9763 17.2876H12.9283V19.3356H14.9763V17.2876Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.024 15.2396H14.976V17.2876H17.024V15.2396Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1198 15.2396H19.0718V17.2876H21.1198V15.2396Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.072 17.2876H17.024V19.3356H19.072V17.2876Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.024 19.3355H14.976V21.3835H17.024V19.3355Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9279 19.3359H11.0121C11.1878 20.0972 11.5332 20.7939 12.007 21.3839H12.9279V19.3359Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0718 21.3839H19.9927C20.4665 20.7939 20.8118 20.0972 20.9876 19.3359H19.0718V21.3839V21.3839Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9283 21.3838V22.2774C13.524 22.7256 14.22 23.0471 14.9763 23.2012V21.3838H12.9283Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.024 21.3838V23.2012C17.7803 23.0471 18.4763 22.7256 19.072 22.2774V21.3838H17.024Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_21525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatia);
export default __webpack_public_path__ + "static/media/Croatia.92eb44d095b459b872f4ded1abd9e0dd.svg";
export { ForwardRef as ReactComponent };